import React from 'react';

// Profile and statistics completion as the Users page shows it: 80 and up
// positive, 50 and up attention, else critical. Shared by the Users table
// and the Assign players dialog. Every colour is a bm token (bm-positive,
// bm-attention, bm-critical, bm-ink, white).
const band = (percent) => (percent >= 80 ? 'positive' : percent >= 50 ? 'attention' : 'critical');

// Badge tone per band: a full profile stays an outline badge, the others
// fill it with the band colour.
const BAND_TONE = { positive: 'outline', attention: 'attention', critical: 'critical' };

// The band colour itself, for a dot on a white row.
const BAND_COLOUR = { positive: '#1f9d55', attention: '#edd200', critical: '#e2241a' };

// The dot on a pctTone badge. A filled badge already carries the band
// colour, so its dot takes the badge's text colour (ink on attention, white
// on critical) and stays visible instead of melting into the fill.
const BADGE_DOT = { positive: '#1f9d55', attention: '#2c2c2c', critical: '#ffffff' };

export const pctTone = (percent) => BAND_TONE[band(percent)];
export const pctDot = (percent) => BADGE_DOT[band(percent)];
export const pctBandDot = (percent) => BAND_COLOUR[band(percent)];

export const CompletionPct = ({ value, title }) => (
  <span className="inline-flex items-center gap-1" title={title}>
    <span className="h-[7px] w-[7px] rounded-full" style={{ background: pctBandDot(value) }} />
    {value}%
  </span>
);

// "profile% / stats%" in one line.
export const CompletionPair = ({ profile, stats, profileTitle, statsTitle, className = '' }) => (
  <div className={`flex items-center gap-1.5 bm-label-xs text-bm-muted ${className}`.trim()} title="Profile completion / statistics completion">
    <CompletionPct value={profile} title={profileTitle || `Profile ${profile}% complete`} />
    <span className="text-bm-tertiary">/</span>
    <CompletionPct value={stats} title={statsTitle || `Statistics ${stats}% complete`} />
  </div>
);
